import { Component, Input } from '@angular/core';

import { BusinessFuel } from '../../business/models/business-fuel.model';


@Component({
  selector: 'app-fuel',
  templateUrl: './fuel.component.html',
  styleUrls: ['./fuel.component.scss']
})
export class FuelComponent {
  @Input() fuel: BusinessFuel;

  /**
   * Returns formatted fuel type
   */
  get type(): string {
    return BusinessFuel.formatFuelType(this.fuel.fuelType);
  }

  /**
   * Returns formatted service type
   */
  get serviceType(): string {
    return BusinessFuel.formatServiceTypeShort(this.fuel.service);
  }
}
